export default "__VITE_ASSET__231f2c47__"